import {
	Component,
	OnInit,
	Input,
	Output,
	SimpleChanges,
	ElementRef,
	EventEmitter,
	OnChanges,
	ViewChild,
} from "@angular/core";

@Component({
	selector: "app-image-navigator",
	templateUrl: "./image-navigator.directive.html",
	styleUrls: ["./image-navigator.directive.scss"],
})
export class ImageNavigatorDirective implements OnInit {
	@ViewChild("btnswrapper", { static: true }) btnswrapper: ElementRef;
	@ViewChild("btnscontainer", { static: true }) btncontainer: ElementRef;
	@Input() images_length: number; // length of images needs to show
	@Input() activateButtons?: boolean = true; // controll the next ,prev button
	@Input() activateNextButton?: boolean = true; // controll the next ,prev button
	@Input() currentIndex?: number = 0;
	@Input() isClickable?: boolean = true;
	@Input() maxItems?: any;
	@Input() posLeft?: any;
	@Input() completedItems?: any;
	@Input() highlightEffect: string;
	@Output() indexChange: EventEmitter<any> = new EventEmitter<any>(); // emits when button click
	public indexArray: any[] = [];
	// public currentIndex:number=0;
	constructor(private elementRef: ElementRef) {
		console.log("ImageNavigatorDirective");
	}
	ngOnInit() {
		this.createIndexArr();
	}

	ngOnChanges(simplechanges: SimpleChanges) {
		this.setupIndexes(simplechanges);
		this.changeIndex(simplechanges);
		this.configMaxItems(simplechanges);
		this.configPosition(simplechanges);
	}
	private createIndexArr() {
		if (this.images_length) {
			for (let i: number = 0; i < this.images_length; i++) {
				const indexObj: any = { index: i, selected: false, visited: false };
				this.indexArray.push(indexObj);
			}
		}
		if (this.indexArray && this.indexArray.length && this.currentIndex >= 0) {
			this.indexArray[this.currentIndex].selected = true;
		}
		if (this.indexArray && this.indexArray.length && this.completedItems >= 0) {
			for (let i in this.indexArray) {
				this.indexArray[i].visited =
					parseInt(i) <= this.completedItems ? true : false;
			}
		}
	}
	private setupIndexes(changes: any) {
		if (
			changes.hasOwnProperty("images_length") &&
			!changes["images_length"].isFirstChange() &&
			changes["images_length"]["currentValue"]
		) {
			this.createIndexArr();
		}
	}
	private configMaxItems(changes: any) {
		if (
			changes.hasOwnProperty("maxItems") &&
			changes["maxItems"]["currentValue"]
		) {
			this.btnswrapper.nativeElement.style.width = `${this.maxItems * 20}px`;
			this.btncontainer.nativeElement.style.width = `${
				this.images_length * 20
			}px`;
		}
	}
	private changeIndex(changes: any) {
		if (
			changes.hasOwnProperty("currentIndex") &&
			changes["currentIndex"]["currentValue"]
		) {
			if (this.indexArray[this.currentIndex - 1]) {
				this.indexArray[this.currentIndex - 1].selected = false;
				this.indexArray[this.currentIndex - 1].visited = true;
			}
			if (this.indexArray && this.indexArray.length) {
				this.indexArray[this.currentIndex].selected = true;
			}
		}
	}
	private configPosition(changes: any) {
		if (
			changes.hasOwnProperty("posLeft") &&
			changes["posLeft"]["currentValue"]
		) {
			this.btncontainer.nativeElement.style.marginLeft = `${this.posLeft}px`;
		}
	}
	public backBtnClick(event) {
		if (this.currentIndex > 0) {
			this.currentIndex = this.currentIndex - 1;
		}
		for (let item of this.indexArray) {
			item.selected = false;
		}
		this.indexArray[this.currentIndex].selected = true;
		if (this.currentIndex <= this.images_length - this.maxItems) {
			let mLeft: any = getComputedStyle(
				this.btncontainer.nativeElement
			).marginLeft.replace("px", "");
			//if(parseInt(mLeft)>=0){return;}
			let spaceToRight: number =
				this.currentIndex == this.images_length - this.maxItems ? 10 : 20;
			//spaceToRight = (this.currentIndex ==0)?10:spaceToRight;
			//spaceToRight = (mLeft=='-10')?10:spaceToRight;
			if (parseInt(mLeft) >= -10) {
				this.btncontainer.nativeElement.style.marginLeft = `0px`;
			} else {
				this.btncontainer.nativeElement.style.marginLeft = `${
					parseInt(mLeft) + 1 * spaceToRight
				}px`;
			}
			this.btncontainer.nativeElement.style.transition = "all .1s";
		}
		let marginLeft: any =
			this.btncontainer.nativeElement.style.marginLeft.replace("px", "");
		this.indexChange.emit({
			type: "back",
			index: this.currentIndex,
			pos: marginLeft,
		});
	}
	public nextBtnClick(event) {
		if (this.currentIndex < this.indexArray.length - 1) {
			this.currentIndex = this.currentIndex + 1;
		}
		if (this.indexArray[this.currentIndex - 1]) {
			this.indexArray[this.currentIndex - 1].selected = false;
			this.indexArray[this.currentIndex - 1].visited = true;
		}
		if (this.currentIndex >= this.indexArray.length - 1) {
			this.indexArray[this.currentIndex].visited = true;
		}
		this.indexArray[this.currentIndex].selected = true;

		let mLeft: any = getComputedStyle(
			this.btncontainer.nativeElement
		).marginLeft.replace("px", "");
		let wrapperWidth: any = this.btnswrapper.nativeElement.style.width.replace(
			"px",
			""
		);
		let containerWidth: any =
			this.btncontainer.nativeElement.style.width.replace("px", "");
		let scrolltoRight: boolean =
			parseInt(containerWidth) + parseInt(mLeft) > parseInt(wrapperWidth)
				? true
				: false;
		//console.log('scrolltoRight',scrolltoRight, parseInt(containerWidth)+ parseInt(mLeft));
		if (
			this.currentIndex + 1 >= this.maxItems &&
			this.images_length > this.maxItems &&
			scrolltoRight
		) {
			let spaceToleft: number =
				parseInt(mLeft) == 0 || this.currentIndex + 1 >= this.images_length
					? 10
					: 20;
			this.btncontainer.nativeElement.style.marginLeft = `${
				parseInt(mLeft) - 1 * spaceToleft
			}px`;
			this.btncontainer.nativeElement.style.transition = "all .1s";
		}
		let marginLeft: any =
			this.btncontainer.nativeElement.style.marginLeft.replace("px", "");
		this.indexChange.emit({
			type: "next",
			index: this.currentIndex,
			pos: marginLeft,
		});
	}
}
